import CNRPatches from "./CNRPatches";

export default CNRPatches;

